import React from 'react'
import { authActions } from '../../store/auth-Slice';
import { getRefreshToken } from '../Api';

const postRequest = async (uri, data, headers, dispatch, signal) => {
    try {
        const response = await fetch(uri, {
            method: 'POST',
            body: JSON.stringify(data),
            signal,
            headers: {
                'Content-Type': 'application/json',
                Authorization: headers.token,
                Client: headers.client,
            },
        });

        if (!response.ok) {
            if (response.status === 401) {
                const newApiData = await getRefreshToken();
                dispatch
                    ? dispatch(authActions.UpdateToken(newApiData))
                    : window.location.reload();

                return await postRequest(uri, data, newApiData, dispatch, signal);
            }
        }

        return await response.json();

    } catch (err) {
        console.log(err);
        if (err.name === "AbortError") {
            throw err; 
        }
        throw new Error("Network error");
    }

};

export default postRequest